import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';
import { batchEventsConfig } from '@v2/pages/part/details/navigation/config';
import { NAVIGATION_CONFIG } from '@v2/pages/common/constants/base.constants';

const PartDetailsBatchEventsStack = createStackNavigator();

const PartDetailsBatchEventsNavigator = (props: any) => {
  return (
    <PartDetailsBatchEventsStack.Navigator screenOptions={NAVIGATION_CONFIG}>
      {batchEventsConfig.map(({ Component, name }) => (
        <PartDetailsBatchEventsStack.Screen key={name} name={name} component={Component} initialParams={props.route?.params} />
      ))}
    </PartDetailsBatchEventsStack.Navigator>
  );
};

export { PartDetailsBatchEventsNavigator };
